import {
  Box,
  Container,
  Wrap,
  Text,
  Link,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';
import { useRef } from 'react';
import Pagination from '../../components/Pagination';
import PrintablePdf from '../../components/PrintablePdf';
import RoadMaintenanceDeliveryCosts from './components/report-sections/RoadMaintenanceDeliveryCosts';
import RoadMaintenanceDeliveryActivitiesRoads from './components/report-sections/RoadMaintenanceDeliveryActivitiesRoads';
import RoadMaintenanceDeliveryActivitiesDrainage from './components/report-sections/RoadMaintenanceDeliveryActivitiesDrainage';
import RoadMaintenanceDeliveryOtherWorks from './components/report-sections/RoadMaintenanceDeliveryOtherWorks';
import RoadMaintenanceDeliveryReportHeader from './components/report-headers/RoadMaintenanceDeliveryReportHeader';
import RoadMaintenanceDeliveryQuarterlyCosts from './components/report-sections/RoadMaintenanceDeliveryQuarterlyCosts';
import DataDisclaimer from '../../components/DataDisclaimer';
import RoadMaintenanceDeliveryPavementResurfacing from './components/report-sections/RoadMaintenanceDeliveryPavementResurfacing';

function RoadMaintenanceDelivery() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Road Maintenance Delivery"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>
                This page presents a range of information on completed works for the network.
              </Text>
              <Text>
                The bulk of the results on this page is sourced from NZTA via the
                {' '}
                <Link href="https://www.nzta.govt.nz/partners/planning-and-investment/learning-and-resources/transport-data/data-and-tools" isExternal>NZTA Data and Tools web page</Link>
                . This information is supplied to NZTA by RCAs in their Annual Achievement Returns, due in mid-July each year.
              </Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <RoadMaintenanceDeliveryReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper" mb={1}>
            <RoadMaintenanceDeliveryQuarterlyCosts />
            <RoadMaintenanceDeliveryCosts />
            <RoadMaintenanceDeliveryActivitiesRoads />
            <RoadMaintenanceDeliveryPavementResurfacing />
            <RoadMaintenanceDeliveryActivitiesDrainage />
            <RoadMaintenanceDeliveryOtherWorks />
          </Wrap>
          <DataDisclaimer />
        </Box>
      </Container>
    </MainLayout>
  );
}

export default RoadMaintenanceDelivery;
